import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/motion";
import { useLang } from "@/context/LangContext";
import { PageLayout } from "@/components/PageLayout";

const SectionBlock = ({ s, i }) => {
  const { pick } = useLang();
  const img = fileUrl(s?.image_url);
  const heading = pick(s?.heading_en, s?.heading_mh);
  const body = pick(s?.body_en, s?.body_mh);
  return (
    <FadeUp className={`grid items-center gap-10 py-14 md:grid-cols-2 ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}>
      {img && (
        <div className="relative h-[280px] overflow-hidden rounded-t-[999px] md:h-[420px]">
          <img src={img} alt={heading || ""} className="absolute inset-0 h-full w-full object-cover" />
        </div>
      )}
      <div className={img ? "" : "md:col-span-2 md:max-w-3xl"}>
        {heading && <h2 className="font-display text-4xl font-semibold leading-tight text-[#F4EEE2] md:text-5xl">{heading}</h2>}
        {body && <p className="mt-5 whitespace-pre-line text-base leading-relaxed text-[#C9D0DB] md:text-lg">{body}</p>}
      </div>
    </FadeUp>
  );
};

export default function CustomPage() {
  const { slug } = useParams();
  const { pick } = useLang();
  const [page, setPage] = useState(null);
  useEffect(() => {
    setPage(null);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data || false)).catch(() => setPage(false));
  }, [slug]);
  if (page === false) return <Navigate to="/" replace />;
  if (!page) return <main className="min-h-screen" />;
  const sections = Array.isArray(page.sections) ? page.sections : [];
  return (
    <main data-testid={`custom-page-${slug}`}>
      <PageLayout page={`page:${slug}`} sections={{
        hero: <PageHero key={slug} testid="custom-page-hero" over="Awa In Kelet" title={pick(page.title_en, page.title_mh)} lead={pick(page.intro_en, page.intro_mh)} image={fileUrl(page.hero_url) || undefined} />,
        sections: sections.length > 0 && (
      <section className="mx-auto max-w-[1400px] px-5 pb-24 md:px-10">
        {sections.map((s, i) => <SectionBlock key={i} s={s} i={i} />)}
      </section>
        ),
      }} />
    </main>
  );
}
